<template lang="html">
    <li class="founder">
          {{founder.name}} <span v-if="founder.position">- {{founder.position}}</span> <a v-if="founderLink" :href="founderLink" target="_blank" class="picto_link_linkedin"><img :src="require('@/assets/linkedin.svg')" alt=""/></a>
        </li>

</template>

<script>
export default {
  name : "FounderLine",
  props: ["founder"],
  computed:{
    founderLink: function(){
      if(this.founder.linkedin_profile){
        if(this.founder.linkedin_profile.startsWith("https://")){
          return this.founder.linkedin_profile;
        }
        else{
          return "https://"+this.founder.linkedin_profile;
        }
      }
      else{
        return null;
      }

    }
  }

}
</script>

<style lang="css" scoped>

.founder{
  font-size: 16px;
  line-height: 28px;
  margin-left:0px;
  padding-left:0px;
}
.founder .picto_link_linkedin{
  margin-left:20px;
}

</style>
